import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "bootstrap/dist/css/bootstrap.min.css"; // importing bootstrap css for reactStrap
import "bootstrap/dist/js/bootstrap"; // importing bootstrap Js for collapse
import "../node_modules/font-awesome/css/font-awesome.min.css";
import '../node_modules/react-modal-video/scss/modal-video.scss';


ReactDOM.render(<App />, document.getElementById("root"));
try {
  if (process.env.NODE_ENV != "development") {
    console.log = function () {}; //disable the console log
  }
} catch (err) {
  console.log = function () {}; //disable the console log
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
